export const QUIZ_API_URL = {
  convertUser: 'catalog/request' as const,
  updateProfile: 'profile' as const
}
